export enum AllocateType {
    'CALCULATED' = 'calculated',
    'PEAK' = 'peak',
    'NAMEPLATE' = 'nameplate'
}